import callApi from './personnelService';

const basePath = `/frontend/api/one-to-one/${process.env.VUE_APP_COMPANY_KEY}/reservation`;

export const getReservation = (statusInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-reservation`,
  body: statusInfo
});

export const getReservationTypeList = () => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-reservation-type-list`
});

export const getReservationTimeList = () => callApi({
  method: 'POST',
  endpoint: `${basePath}/get-reservation-time-list`
});

export const updateReservation = (updateInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/update`,
  body: updateInfo
});

export const deleteApi = (deleteInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/delete`,
  body: deleteInfo
});

export const check = (checkInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/check`,
  body: checkInfo
});

export const success = (successInfo) => callApi({
  method: 'POST',
  endpoint: `${basePath}/success`,
  body: successInfo
});
